import { createElement } from "../util/ui/Element";
import { setTextIfNew } from "../util/ui/Node";
export function setupToggle(toggledElement, toggleClassName, showText, hideText, isHidden, onToggled) {
    if (isHidden)
        toggledElement.classList.add("-hidden");
    else
        toggledElement.classList.remove("-hidden");
    const toggleContainer = createElement("div", "container rightAlign", toggledElement.parentElement);
    const toggle = createElement("button", toggleClassName, toggleContainer);
    toggle.onclick = () => {
        const isHidden = toggledElement.classList.toggle("-hidden");
        setTextIfNew(toggle, isHidden ? showText : hideText);
        onToggled(isHidden);
    };
    toggle.textContent = isHidden ? showText : hideText;
    toggledElement.after(toggleContainer);
}
